import React from 'react';

import type { IntlShape } from 'react-intl';

import type { ToolbarItem } from '@atlaskit/editor-common/extensions';
import type {
	Command,
	DropdownOptions,
	Icon,
	PublicPluginAPI,
} from '@atlaskit/editor-common/types';
import ClockIcon from '@atlaskit/icon/core/clock';

import type { AgentManagedExtensionPlugin } from '../../common/agentManagedExtensionPluginType';
import { messages } from '../../common/messages';
import { AutoUpdateIntervalMenu } from './auto-update-interval/AutoUpdateIntervalMenu';
import { createHydrateSelectionCommand } from './auto-update-interval/commands';

export const getAutoUpdateIntervalToolbarItem = (
	intl: IntlShape,
	api?: PublicPluginAPI<[AgentManagedExtensionPlugin]>,
): ToolbarItem => {
	const label = intl.formatMessage(messages.autoUpdateInterval);
	const dropdownOptions: DropdownOptions<Command> = {
		height: 168,
		render: ({ dispatchCommand, hide }) =>
			React.createElement(AutoUpdateIntervalMenu, {
				api,
				dispatchCommand,
				hide,
				intl,
				label,
			}),
		width: 220,
	};

	return {
		type: 'dropdown',
		id: 'agent-managed-extension-auto-update-interval',
		title: label,
		tooltip: label,
		icon: React.createElement(ClockIcon, { label }) as unknown as Icon,
		dropdownWidth: 220,
		hideExpandIcon: true,
		onToggle: createHydrateSelectionCommand(),
		showSelected: false,
		testId: 'agent-managed-extension-auto-update-interval-trigger',
		options: dropdownOptions,
	};
};
